var _excluded = ["color"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { getColor } from '../Theme/selectors';
import Icon from './template';
var Cross = function Cross(_ref) {
  var color = _ref.color,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Icon, _extends({}, otherProps, {
    renderPaths: function renderPaths(uiTheme) {
      var style = {};
      if (color) {
        style.fill = getColor(uiTheme, color);
      }
      return /*#__PURE__*/React.createElement("polygon", {
        id: "Path",
        style: style,
        fillRule: "nonzero",
        points: "36 7.22285714 32.7771429 4 20 16.7771429 7.22285714 4 4 7.22285714 16.7771429 20 4 32.7771429 7.22285714 36 20 23.2228571 32.7771429 36 36 32.7771429 23.2228571 20"
      });
    }
  }));
};
Cross.defaultProps = {
  color: null
};
export default Cross;
export var name = 'Cross';
export var availableProps = ['color'];